import React from "react";
import { useLocation } from "react-router-dom";
import IdleTimer from "./IdleTimer";

const IdleTimerWrapper = (props) => {
	const location = useLocation();
	return <IdleTimer {...props} />;
};

export default IdleTimerWrapper;
